import { autoCapitalize } from '@/utils/autoCapitalize'
import { MedicalReferralDetailsData } from './MedicalReferralDetailsMapper.types'
import { formatCPF } from '@/utils/formatCPF/formatCPF'
import {
  replaceUnderscoreAndFormatSentence,
  replaceUnderscoreWithEmptySpace,
} from '@/utils/replaceString'
import { parse } from 'date-fns'

class MedicalReferralDetailsMapper {
  toDomain(persistenceMedicalReferralDetail: MedicalReferralDetailsData) {
    const handleFormatDate = (date: string) => {
      if (date) {
        return parse(date, 'dd/MM/yyyy', new Date())
      }
    }

    return {
      clinicId: persistenceMedicalReferralDetail?.clinicId,
      medicalReferralId: persistenceMedicalReferralDetail?.id,
      patientName: autoCapitalize(
        persistenceMedicalReferralDetail?.patient?.name,
      ),
      cpfPatient: formatCPF(persistenceMedicalReferralDetail?.patient?.cpf),
      birthPatientDate: persistenceMedicalReferralDetail?.patient?.birthDate,
      clinicName: autoCapitalize(
        persistenceMedicalReferralDetail?.patient?.clinicName,
      ),
      healthCardNumber:
        persistenceMedicalReferralDetail?.patient?.healthInsuranceCardNumber,
      patientEmail: persistenceMedicalReferralDetail?.patient?.email,
      patientStatus: replaceUnderscoreWithEmptySpace(
        persistenceMedicalReferralDetail?.medicalReferralDetails?.status,
      ),
      registerDate: persistenceMedicalReferralDetail?.patient?.registrationDate,
      doctorName:
        persistenceMedicalReferralDetail?.medicalReferralDetails
          ?.professionalName,
      crm: persistenceMedicalReferralDetail?.medicalReferralDetails
        ?.councilNumber,
      ufCrm: persistenceMedicalReferralDetail?.medicalReferralDetails?.uf,
      emissionDate: handleFormatDate(
        persistenceMedicalReferralDetail?.medicalReferralDetails?.issueDate,
      ),
      expirationDate:
        persistenceMedicalReferralDetail?.medicalReferralDetails
          ?.expirationDate,
      amountAppointments:
        persistenceMedicalReferralDetail?.medicalReferralDetails?.quantityAppointments.toString(),
      hasInformedAppointments: persistenceMedicalReferralDetail
        ?.medicalReferralDetails?.quantityAppointments
        ? 'Sim'
        : 'Não',
      hasCid: persistenceMedicalReferralDetail?.medicalReferralDetails?.cid
        ? 'Sim'
        : 'Não',
      cid: persistenceMedicalReferralDetail?.medicalReferralDetails?.cid,
      fileName: autoCapitalize(
        persistenceMedicalReferralDetail?.documents?.[0]?.name,
      ),
      fileExtension:
        persistenceMedicalReferralDetail?.documents?.[0]?.extension,
      fileUrl: persistenceMedicalReferralDetail?.documents?.[0]?.urlDownload,
      flowType: persistenceMedicalReferralDetail?.type,
      attachments: persistenceMedicalReferralDetail?.documents?.map(file => {
        return {
          fileName: file?.name,
          fileSize: file?.size,
          fileType: file?.type,
          fileUrl: file?.urlDownload,
        }
      }),
      complianceReason:
        persistenceMedicalReferralDetail?.complianceReason?.map(reason =>
          replaceUnderscoreAndFormatSentence(reason),
        ) ?? [],
      latestMedicalReferral:
        persistenceMedicalReferralDetail?.latestMedicalReferral,
    }
  }
}

export default new MedicalReferralDetailsMapper()
